import { HvacTunnelConnectT } from "./HvacTunnelConnectT";
import { HvacVortexFanT } from "./HvacVortexFanT";
import { HvacSuppressorT } from "./HvacSuppressorT";
import { HvacExhaustOpeningT } from "./HvacExhaustOpeningT";


export const ModelsInHvac = {
    "HvacTunnelConnectT": HvacTunnelConnectT,
    "HvacVortexFanT": HvacVortexFanT,
    "HvacSuppressorT": HvacSuppressorT,
    "HvacExhaustOpeningT": HvacExhaustOpeningT,
}